module.exports = __webpack_public_path__ + "static/media/jumbo_banner_5.9c6003cf.jpg";